import React, { useState } from 'react';
import { Button, Divider, List, ListItem, makeStyles, Snackbar, Tooltip, Typography, } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useTranslate } from 'react-admin';
import { CALOGOSRC } from './CALogoSrc.png';
export const AuthSchemeList = props => {
    const { authSchemes, onClick } = props;
    const classes = useStyles(props);
    const [selectedScheme, setSelectedScheme] = useState();
    const translate = useTranslate();
    const onSelectScheme = scheme => {
        if (!scheme.credsReqd) {
            window.location = scheme.url;
            return;
        }
        if (selectedScheme && selectedScheme.uuid === scheme.uuid) {
            setSelectedScheme(null);
            onClick(null);
        }
        else {
            setSelectedScheme(scheme);
            onClick(scheme);
        }
    };
    const StartIcon = props => {
        const { selectedScheme, scheme } = props;
        if (scheme.logo) {
            return (React.createElement("img", { style: { maxHeight: '36px', maxWidth: '36px' }, src: scheme.logo }));
        }
        else {
            return (React.createElement("img", { style: { maxHeight: '36px', maxWidth: '36px' }, src: CALOGOSRC }));
        }
        if (scheme.credsReqd) {
            if (selectedScheme && selectedScheme.uuid === scheme.uuid) {
                return (React.createElement("img", { style: { maxHeight: '36px', maxWidth: '36px' }, src: CALOGOSRC }));
            }
            else {
                return (React.createElement("img", { style: { maxHeight: '36px', maxWidth: '36px' }, src: CALOGOSRC }));
            }
        }
        return null;
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(Snackbar, { anchorOrigin: { vertical: 'top', horizontal: 'center' }, open: !!selectedScheme },
            React.createElement(Alert, { elevation: 6, variant: "outlined", severity: "info" }, selectedScheme
                ? `${translate('apihub.login.notifications.selected_scheme')} ${selectedScheme.name}`
                : null)),
        React.createElement(Divider, { variant: "middle" }),
        React.createElement(Typography, { className: classes.divider, variant: "body1" }, "or"),
        React.createElement(Typography, { variant: "body1" }, translate('apihub.login.actions.sign_in_with')),
        React.createElement(List, null, authSchemes.map((scheme, i) => (React.createElement(ListItem, { key: scheme.name, disableGutters: true },
            React.createElement(Tooltip, { key: i, title: scheme.description, placement: "right-start" },
                React.createElement(Button, { variant: "outlined", startIcon: React.createElement(StartIcon, { scheme: scheme, selectedScheme: selectedScheme }), className: classes.listButton, onClick: () => onSelectScheme(scheme) },
                    React.createElement("span", { className: classes.listButtonLabelName },
                        scheme.name,
                        React.createElement("span", { className: classes.listButtonLabelDescription }, scheme.description))))))))));
};
const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(3),
    },
    listButtonLabelName: {
        width: '100%',
        textAlign: 'center',
    },
    listButtonLabelDescription: {
        fontSize: '0.7rem',
        display: 'block',
        color: theme.palette.text.secondary,
        textTransform: 'none',
    },
    listButton: {
        width: '100%',
        justifyContent: 'start',
    },
    divider: {
        marginTop: '-13px',
        marginBottom: theme.spacing(2),
        margin: '0 auto',
        width: '20px',
        textAlign: 'center',
        backgroundColor: theme.palette.background.default,
    },
}), {
    name: 'Layer7LoginAuthSchemeList',
});
//# sourceMappingURL=AuthSchemeList.js.map